"use client";
import { useState } from "react";
import { useRouter } from "next/navigation";
import PropTypes from "prop-types";

import { kvkkContractApprove } from "services/auth";

import Button from "components/common/button";

import InformationIcon from "assets/svg/information-icon.svg";

import styles from "./styles.module.css";

const InformationModal = ({ setContractModalOpen }) => {
  const router = useRouter();
  const [buttonLoadings, setButtonLoadings] = useState({
    approve: false,
    reject: false,
  });

  const sendKvkkContractResponse = async (buttonType, status) => {
    setButtonLoadings({
      ...buttonLoadings,
      [buttonType]: true,
    });
    try {
      const response = await kvkkContractApprove({
        templateId: 5,
        version: 2,
        approved: status,
        formType: "excliptconsent@popup",
        application: "desktop-web",
      });
      if (response.status === "success") {
        setButtonLoadings({
          ...buttonLoadings,
          [buttonType]: false,
        });
        router.push("/");
      }
    } catch (error) {
      setButtonLoadings({
        ...buttonLoadings,
        [buttonType]: false,
      });
      console.error({ error });
    }
  };

  return (
    <div className={styles.infoWrapper}>
      <div className={styles.informationIcon}>
        <InformationIcon />
      </div>
      <p className={styles.infoTitle}>Bilgilendirme</p>
      <p className={styles.infoDescription}>
        Sana duyuru ve kampanya maili gönderebilmemiz için “Kişisel Verilerin Korunması Kanunu” kapsamında onayına
        ihtiyacımız var. Açık Rıza Metni’ni okumak için{" "}
        <b onClick={() => setContractModalOpen(true)} className={styles.openExplicitConsent}>
          tıklayınız
        </b>
      </p>
      <div className={styles.confirmButton}>
        <Button
          size="M"
          isLoading={buttonLoadings.approve}
          onClick={() => {
            sendKvkkContractResponse("approve", true);
          }}
        >
          Tamam
        </Button>
      </div>
      <div className={styles.rejectButton}>
        <Button
          size="S"
          isLoading={buttonLoadings.reject}
          outline
          onClick={() => {
            sendKvkkContractResponse("reject", false);
          }}
        >
          İstemiyorum
        </Button>
      </div>
    </div>
  );
};

InformationModal.propTypes = {
  setContractModalOpen: PropTypes.func.isRequired,
};

export default InformationModal;
